import React from "react";

export default function ChinaNewYearFrame4({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>{".cls-4cn1{fill:#ffe7e6}.cls-4cn2{fill:#d12519}"}</style>
        </defs>
        <path
          d="M352 171.91c39.15-2.43 76.01 19.45 92.63 54.98 38.38-8.21 78.09 7.99 99.78 40.7 21.69 32.71 21.15 75.6-1.35 107.76 26.31 29.13 32.15 71.62 14.67 106.76-17.48 35.14-54.88 56.13-93.99 52.72-12.1 37.32-45.97 63.58-85.12 66.01-39.15 2.43-76.01-19.45-92.63-54.98-38.38 8.21-78.09-7.99-99.78-40.7-21.69-32.71-21.15-75.6 1.35-107.76-26.31-29.13-32.15-71.62-14.67-106.76 17.48-35.14 54.88-56.13 93.99-52.72 12.1-37.32 45.97-63.58 85.12-66.01Z"
          className="cls-4cn1"
        />
        <path
          d="M352.57 184.16c36.92-2.29 71.66 18.34 87.33 51.84 36.19-7.74 73.63 7.53 94.08 38.37 20.45 30.84 19.94 71.28-1.28 101.6 24.81 27.47 30.31 67.53 13.83 100.66-16.48 33.14-51.75 52.92-88.62 49.71-11.41 35.18-43.34 59.95-80.25 62.24-36.92 2.29-71.66-18.34-87.33-51.84-36.19 7.74-73.63-7.53-94.08-38.37-20.45-30.84-19.94-71.28 1.28-101.6-24.81-27.47-30.31-67.53-13.83-100.66 16.48-33.14 51.75-52.92 88.62-49.71 11.41-35.18 43.34-59.95 80.25-62.24Z"
          className="cls-4cn2"
        />
        <circle cx={363.3} cy={388.91} r={37.77} className="cls-4cn1" />
        <path
          d="M364.56 387.83c-.52 0-.94-.42-.94-.94V271.55a.939.939 0 1 1 1.88 0v115.34c0 .52-.42.94-.94.94Z"
          className="cls-4cn1"
        />
        <path
          d="M364.56 504.66c-.52 0-.94-.42-.94-.94V388.38a.939.939 0 1 1 1.88 0v115.34c0 .52-.42.94-.94.94Z"
          className="cls-4cn1"
        />
        <path
          d="M363.82 389.32H248.48a.939.939 0 1 1 0-1.88h115.34a.939.939 0 1 1 0 1.88Z"
          className="cls-4cn1"
        />
        <path
          d="M480.65 389.32H365.31a.939.939 0 1 1 0-1.88h115.34a.939.939 0 1 1 0 1.88Z"
          className="cls-4cn1"
        />
        <path
          d="M364.05 388.29a.94.94 0 0 1-.65-.26l-83.03-80.05a.945.945 0 0 1-.02-1.33c.36-.37.96-.38 1.33-.02l83.03 80.05a.945.945 0 0 1-.66 1.62Z"
          className="cls-4cn1"
        />
        <path
          d="M448.15 469.37a.94.94 0 0 1-.65-.26l-83.03-80.05a.945.945 0 0 1-.02-1.33c.36-.37.96-.38 1.33-.02l83.03 80.05a.945.945 0 0 1-.66 1.62Z"
          className="cls-4cn1"
        />
        <path
          d="M284.55 472.89a.94.94 0 0 1-.65-.26.945.945 0 0 1-.02-1.33l80.05-83.03c.36-.37.96-.38 1.33-.02s.38.96.02 1.33l-80.05 83.03c-.18.19-.43.29-.68.29Z"
          className="cls-4cn1"
        />
        <path
          d="M365.63 388.78a.94.94 0 0 1-.65-.26.945.945 0 0 1-.02-1.33l80.05-83.03c.36-.37.96-.38 1.33-.02.37.36.38.96.02 1.33l-80.05 83.03c-.18.19-.43.29-.68.29ZM363.4 387.08c-.28 0-.54-.17-.65-.44l-32.67-80.3a.707.707 0 0 1 1.31-.53l32.67 80.3a.707.707 0 0 1-.66.97Z"
          className="cls-4cn1"
        />
        <path
          d="M396.49 468.42c-.28 0-.54-.17-.65-.44l-32.67-80.3a.707.707 0 0 1 1.31-.53l32.67 80.3a.707.707 0 0 1-.66.97Z"
          className="cls-4cn1"
        />
        <path
          d="M283 420.99a.707.707 0 0 1-.26-1.36l80.3-32.67a.707.707 0 0 1 .53 1.31l-80.3 32.67c-.09.04-.18.05-.27.05Z"
          className="cls-4cn1"
        />
        <path
          d="M364.34 387.91a.707.707 0 0 1-.26-1.36l80.3-32.67a.707.707 0 0 1 .53 1.31l-80.3 32.67c-.09.04-.18.05-.27.05Z"
          className="cls-4cn1"
        />
        <path
          d="M363.31 387.47c-.09 0-.19-.02-.28-.06l-79.79-33.88c-.36-.15-.53-.57-.37-.93s.57-.53.93-.37l79.79 33.88a.7.7 0 0 1 .37.93c-.11.27-.38.43-.65.43Z"
          className="cls-4cn1"
        />
        <path
          d="M444.13 421.79c-.09 0-.19-.02-.28-.06l-79.79-33.88a.7.7 0 0 1-.37-.93.7.7 0 0 1 .93-.37l79.79 33.88a.7.7 0 0 1 .37.93c-.11.27-.38.43-.65.43Z"
          className="cls-4cn1"
        />
        <path
          d="M330.24 468.21c-.09 0-.19-.02-.28-.06a.7.7 0 0 1-.37-.93l33.88-79.79a.7.7 0 0 1 .93-.37.7.7 0 0 1 .37.93l-33.88 79.79c-.11.27-.38.43-.65.43Z"
          className="cls-4cn1"
        />
        <path
          d="M364.55 387.39c-.09 0-.19-.02-.28-.06a.7.7 0 0 1-.37-.93l33.88-79.79a.7.7 0 0 1 .93-.37.7.7 0 0 1 .37.93l-33.88 79.79c-.11.27-.38.43-.65.43Z"
          className="cls-4cn1"
        />
        <circle cx={322.53} cy={283.59} r={7.98} className="cls-4cn1" />
        <circle cx={406.64} cy={286.18} r={7.98} className="cls-4cn1" />
        <circle cx={465.69} cy={346.22} r={7.98} className="cls-4cn1" />
        <circle cx={464.21} cy={427.61} r={7.98} className="cls-4cn1" />
        <circle cx={404.23} cy={485.56} r={7.98} className="cls-4cn1" />
        <circle cx={322.53} cy={485.56} r={7.98} className="cls-4cn1" />
        <circle cx={264.22} cy={426.69} r={7.98} className="cls-4cn1" />
        <circle cx={264.22} cy={341.8} r={7.98} className="cls-4cn1" />
        <path
          d="M1617.82 1525.04c27.67-1.72 53.71 13.74 65.45 38.85 27.12-5.8 55.19 5.64 70.51 28.76 15.33 23.12 14.95 53.42-.96 76.15 18.59 20.58 22.72 50.61 10.36 75.45-12.35 24.83-38.78 39.66-66.42 37.26-8.55 26.37-32.48 44.93-60.15 46.65-27.67 1.72-53.71-13.74-65.45-38.85-27.12 5.8-55.19-5.64-70.51-28.76-15.33-23.12-14.95-53.42.96-76.15-18.59-20.58-22.72-50.61-10.36-75.45 12.35-24.83 38.78-39.66 66.42-37.26 8.55-26.37 32.48-44.93 60.15-46.65Z"
          className="cls-4cn1"
        />
        <path
          d="M1618.23 1533.7c26.09-1.62 50.64 12.96 61.71 36.63 25.57-5.47 52.03 5.32 66.48 27.12 14.45 21.8 14.09 50.37-.9 71.8 17.53 19.41 21.42 47.72 9.77 71.13-11.65 23.42-36.57 37.4-62.62 35.13-8.06 24.86-30.63 42.36-56.71 43.98-26.09 1.62-50.64-12.96-61.71-36.63-25.57 5.47-52.03-5.32-66.48-27.12-14.45-21.8-14.09-50.37.9-71.8-17.53-19.41-21.42-47.72-9.77-71.13 11.65-23.42 36.57-37.4 62.62-35.13 8.06-24.86 30.63-42.36 56.71-43.98Z"
          className="cls-4cn2"
        />
        <circle cx={1625.81} cy={1678.39} r={26.69} className="cls-4cn1" />
        <path
          d="M1626.7 1677.62a.66.66 0 0 1-.66-.66v-81.5a.66.66 0 1 1 1.32 0v81.5c0 .37-.3.66-.66.66Z"
          className="cls-4cn1"
        />
        <path
          d="M1626.7 1760.18a.66.66 0 0 1-.66-.66v-81.5a.66.66 0 1 1 1.32 0v81.5c0 .37-.3.66-.66.66Z"
          className="cls-4cn1"
        />
        <path
          d="M1626.18 1678.67h-81.5a.66.66 0 1 1 0-1.32h81.5a.66.66 0 1 1 0 1.32Z"
          className="cls-4cn1"
        />
        <path
          d="M1708.73 1678.67h-81.5a.66.66 0 1 1 0-1.32h81.5a.66.66 0 1 1 0 1.32Z"
          className="cls-4cn1"
        />
        <path
          d="M1626.34 1677.94c-.17 0-.33-.06-.46-.19l-58.68-56.57a.673.673 0 0 1-.02-.94c.26-.26.68-.27.94-.02l58.68 56.57c.26.25.27.68.02.94-.13.14-.3.2-.48.2Z"
          className="cls-4cn1"
        />
        <path
          d="M1685.77 1735.24c-.17 0-.33-.06-.46-.19l-58.68-56.57a.673.673 0 0 1-.02-.94c.26-.26.68-.27.94-.02l58.68 56.57c.26.25.27.68.02.94-.13.14-.3.2-.48.2Z"
          className="cls-4cn1"
        />
        <path
          d="M1570.16 1737.73c-.17 0-.33-.06-.46-.19a.673.673 0 0 1-.02-.94l56.57-58.68c.26-.26.68-.27.94-.02s.27.68.02.94l-56.57 58.68c-.13.14-.3.2-.48.2Z"
          className="cls-4cn1"
        />
        <path
          d="M1627.46 1678.3c-.17 0-.33-.06-.46-.19a.673.673 0 0 1-.02-.94l56.57-58.68c.26-.26.68-.27.94-.02.26.25.27.68.02.94l-56.57 58.68c-.13.14-.3.2-.48.2ZM1625.88 1677.09c-.2 0-.38-.12-.46-.31l-23.08-56.74c-.1-.26.02-.55.27-.65.26-.1.55.02.65.27l23.08 56.74a.501.501 0 0 1-.46.69Z"
          className="cls-4cn1"
        />
        <path
          d="M1649.26 1734.57c-.2 0-.38-.12-.46-.31l-23.08-56.74c-.1-.26.02-.55.27-.65s.55.02.65.27l23.08 56.74a.501.501 0 0 1-.46.69Z"
          className="cls-4cn1"
        />
        <path
          d="M1569.07 1701.06a.499.499 0 0 1-.19-.96l56.74-23.08c.25-.1.55.02.65.27.1.26-.02.55-.27.65l-56.74 23.08c-.06.03-.13.04-.19.04Z"
          className="cls-4cn1"
        />
        <path
          d="M1626.54 1677.67a.499.499 0 0 1-.19-.96l56.74-23.08c.25-.1.55.02.65.27.1.26-.02.55-.27.65l-56.74 23.08c-.06.03-.13.04-.19.04Z"
          className="cls-4cn1"
        />
        <path
          d="M1625.81 1677.37c-.07 0-.13-.01-.19-.04l-56.39-23.94c-.25-.11-.37-.4-.26-.65s.4-.37.66-.26l56.39 23.94a.495.495 0 0 1-.2.95Z"
          className="cls-4cn1"
        />
        <path
          d="M1682.93 1701.62c-.07 0-.13-.01-.19-.04l-56.39-23.94a.495.495 0 0 1-.26-.65c.11-.25.4-.37.66-.26l56.39 23.94a.495.495 0 0 1-.2.95Z"
          className="cls-4cn1"
        />
        <path
          d="M1602.45 1734.43a.495.495 0 0 1-.45-.69l23.94-56.39c.11-.25.4-.37.66-.26.25.11.37.4.26.65l-23.94 56.39a.5.5 0 0 1-.46.3Z"
          className="cls-4cn1"
        />
        <path
          d="M1626.7 1677.31a.495.495 0 0 1-.45-.69l23.94-56.39c.11-.25.4-.37.66-.26.25.11.37.4.26.65l-23.94 56.39a.5.5 0 0 1-.46.3Z"
          className="cls-4cn1"
        />
        <circle cx={1597} cy={1603.96} r={5.64} className="cls-4cn1" />
        <circle cx={1656.43} cy={1605.79} r={5.64} className="cls-4cn1" />
        <circle cx={1698.16} cy={1648.22} r={5.64} className="cls-4cn1" />
        <circle cx={1697.12} cy={1705.73} r={5.64} className="cls-4cn1" />
        <circle cx={1654.73} cy={1746.68} r={5.64} className="cls-4cn1" />
        <circle cx={1597} cy={1746.68} r={5.64} className="cls-4cn1" />
        <circle cx={1555.79} cy={1705.08} r={5.64} className="cls-4cn1" />
        <circle cx={1555.79} cy={1645.09} r={5.64} className="cls-4cn1" />
        <path
          d="M1391.36 1636.42c12.33-.77 23.94 6.12 29.17 17.32 12.09-2.59 24.6 2.52 31.43 12.82 6.83 10.3 6.66 23.81-.43 33.94 8.29 9.17 10.12 22.56 4.62 33.63-5.51 11.07-17.29 17.68-29.6 16.61-3.81 11.75-14.48 20.03-26.81 20.79-12.33.77-23.94-6.12-29.17-17.32-12.09 2.59-24.6-2.52-31.43-12.82-6.83-10.3-6.66-23.81.43-33.94-8.29-9.17-10.12-22.56-4.62-33.63 5.51-11.07 17.29-17.68 29.6-16.61 3.81-11.75 14.48-20.03 26.81-20.79Z"
          className="cls-4cn1"
        />
        <path
          d="M1391.54 1640.28c11.63-.72 22.57 5.78 27.51 16.33 11.4-2.44 23.19 2.37 29.63 12.09 6.44 9.71 6.28 22.45-.4 32 7.81 8.65 9.55 21.27 4.36 31.7-5.19 10.44-16.3 16.67-27.91 15.66-3.59 11.08-13.65 18.88-25.28 19.6-11.63.72-22.57-5.78-27.51-16.33-11.4 2.44-23.19-2.37-29.63-12.09-6.44-9.71-6.28-22.45.4-32-7.81-8.65-9.55-21.27-4.36-31.7 5.19-10.44 16.3-16.67 27.91-15.66 3.59-11.08 13.65-18.88 25.28-19.6Z"
          className="cls-4cn2"
        />
        <circle cx={1394.92} cy={1704.77} r={11.9} className="cls-4cn1" />
        <path
          d="M1395.31 1704.43a.3.3 0 0 1-.3-.3v-36.33c0-.16.13-.3.3-.3s.3.13.3.3v36.33a.3.3 0 0 1-.3.3Z"
          className="cls-4cn1"
        />
        <path
          d="M1395.31 1741.22a.3.3 0 0 1-.3-.3v-36.33c0-.16.13-.3.3-.3s.3.13.3.3v36.33a.3.3 0 0 1-.3.3Z"
          className="cls-4cn1"
        />
        <path
          d="M1395.08 1704.9h-36.33c-.16 0-.3-.13-.3-.3s.13-.3.3-.3h36.33c.16 0 .3.13.3.3s-.13.3-.3.3Z"
          className="cls-4cn1"
        />
        <path
          d="M1431.88 1704.9h-36.33c-.16 0-.3-.13-.3-.3s.13-.3.3-.3h36.33c.16 0 .3.13.3.3s-.13.3-.3.3Z"
          className="cls-4cn1"
        />
        <path
          d="M1395.15 1704.57c-.07 0-.15-.03-.21-.08l-26.15-25.21a.29.29 0 0 1 0-.42c.11-.12.3-.12.42 0l26.15 25.21c.12.11.12.3 0 .42-.06.06-.14.09-.21.09Z"
          className="cls-4cn1"
        />
        <path
          d="M1421.64 1730.11c-.07 0-.15-.03-.21-.08l-26.15-25.21a.29.29 0 0 1 0-.42c.11-.12.3-.12.42 0l26.15 25.21c.12.11.12.3 0 .42-.06.06-.14.09-.21.09Z"
          className="cls-4cn1"
        />
        <path
          d="M1370.11 1731.22c-.07 0-.15-.03-.21-.08a.29.29 0 0 1 0-.42l25.21-26.15c.11-.12.3-.12.42 0s.12.3 0 .42l-25.21 26.15c-.06.06-.14.09-.21.09Z"
          className="cls-4cn1"
        />
        <path
          d="M1395.65 1704.73c-.07 0-.15-.03-.21-.08a.29.29 0 0 1 0-.42l25.21-26.15c.11-.12.3-.12.42 0 .12.11.12.3 0 .42l-25.21 26.15c-.06.06-.14.09-.21.09ZM1394.95 1704.19c-.09 0-.17-.05-.21-.14l-10.29-25.29c-.05-.11 0-.24.12-.29.11-.05.24 0 .29.12l10.29 25.29c.05.11 0 .24-.12.29a.31.31 0 0 1-.08.02Z"
          className="cls-4cn1"
        />
        <path
          d="M1405.37 1729.81c-.09 0-.17-.05-.21-.14l-10.29-25.29c-.05-.11 0-.24.12-.29s.24 0 .29.12l10.29 25.29c.05.11 0 .24-.12.29a.31.31 0 0 1-.08.02Z"
          className="cls-4cn1"
        />
        <path
          d="M1369.63 1714.87c-.09 0-.17-.05-.21-.14-.05-.11 0-.24.12-.29l25.29-10.29c.11-.05.24 0 .29.12.05.11 0 .24-.12.29l-25.29 10.29s-.06.02-.08.02Z"
          className="cls-4cn1"
        />
        <path
          d="M1395.24 1704.45c-.09 0-.17-.05-.21-.14-.05-.11 0-.24.12-.29l25.29-10.29c.11-.05.24 0 .29.12.05.11 0 .24-.12.29l-25.29 10.29s-.06.02-.08.02Z"
          className="cls-4cn1"
        />
        <path
          d="M1394.92 1704.31s-.06 0-.09-.02l-25.13-10.67c-.11-.05-.17-.18-.12-.29s.18-.17.29-.12l25.13 10.67c.11.05.17.18.12.29-.04.08-.12.14-.21.14Z"
          className="cls-4cn1"
        />
        <path
          d="M1420.37 1715.12s-.06 0-.09-.02l-25.13-10.67c-.11-.05-.17-.18-.12-.29.05-.11.18-.17.29-.12l25.13 10.67c.11.05.17.18.12.29-.04.08-.12.14-.21.14Z"
          className="cls-4cn1"
        />
        <path
          d="M1384.5 1729.74s-.06 0-.09-.02c-.11-.05-.17-.18-.12-.29l10.67-25.13c.05-.11.18-.17.29-.12.11.05.17.18.12.29l-10.67 25.13c-.04.08-.12.14-.21.14Z"
          className="cls-4cn1"
        />
        <path
          d="M1395.31 1704.29s-.06 0-.09-.02c-.11-.05-.17-.18-.12-.29l10.67-25.13c.05-.11.18-.17.29-.12.11.05.17.18.12.29l-10.67 25.13c-.04.08-.12.14-.21.14Z"
          className="cls-4cn1"
        />
        <circle cx={1382.08} cy={1671.6} r={2.51} className="cls-4cn1" />
        <circle cx={1408.57} cy={1672.41} r={2.51} className="cls-4cn1" />
        <circle cx={1427.16} cy={1691.32} r={2.51} className="cls-4cn1" />
        <circle cx={1426.7} cy={1716.96} r={2.51} className="cls-4cn1" />
        <circle cx={1407.81} cy={1735.21} r={2.51} className="cls-4cn1" />
        <circle cx={1382.08} cy={1735.21} r={2.51} className="cls-4cn1" />
        <circle cx={1363.71} cy={1716.67} r={2.51} className="cls-4cn1" />
        <circle cx={1363.71} cy={1689.93} r={2.51} className="cls-4cn1" />
        <path
          d="M310.13 610.95c34.8 3.44 64.11 27.95 73.67 61.58 34.94-1.75 67.58 18.16 82 50.03 14.42 31.88 7.84 69.54-16.55 94.63 19 29.38 18.08 67.6-2.31 96.04-20.39 28.43-56.29 41.56-90.22 33-15.96 31.11-49.51 49.4-84.31 45.95-34.8-3.44-64.11-27.95-73.67-61.58-34.94 1.75-67.58-18.16-82-50.03-14.42-31.88-7.84-69.54 16.55-94.63-19-29.38-18.08-67.6 2.31-96.04 20.39-28.43 56.29-41.56 90.22-33 15.96-31.11 49.51-49.4 84.31-45.95Z"
          className="cls-4cn2"
        />
        <path
          d="M308.89 621.82c32.81 3.25 60.45 26.35 69.46 58.06 32.95-1.65 63.72 17.12 77.32 47.18 13.6 30.06 7.39 65.56-15.61 89.22 17.91 27.7 17.04 63.74-2.18 90.55-19.22 26.81-53.08 39.19-85.06 31.11-15.05 29.33-46.68 46.57-79.49 43.33-32.81-3.25-60.45-26.35-69.46-58.06-32.95 1.65-63.72-17.12-77.32-47.18-13.6-30.06-7.39-65.56 15.61-89.22-17.91-27.7-17.04-63.74 2.18-90.55 19.22-26.81 53.08-39.19 85.06-31.11 15.05-29.33 46.68-46.57 79.49-43.33Z"
          className="cls-4cn1"
        />
        <circle cx={289.15} cy={803.52} r={33.67} className="cls-4cn2" />
        <path
          d="M290.41 802.74a.824.824 0 0 1-.69-.96l16.44-101.49c.07-.46.5-.77.96-.69s.77.5.69.96l-16.44 101.49c-.07.46-.5.77-.96.69Z"
          className="cls-4cn2"
        />
        <path
          d="M273.76 905.54a.824.824 0 0 1-.69-.96l16.44-101.49c.07-.46.5-.77.96-.69s.77.5.69.96l-16.44 101.49c-.07.46-.5.77-.96.69Z"
          className="cls-4cn2"
        />
        <path
          d="m289.54 803.95-101.49-16.44c-.46-.07-.77-.5-.69-.96s.5-.77.96-.69l101.49 16.44c.46.07.77.5.69.96s-.5.77-.96.69Z"
          className="cls-4cn2"
        />
        <path
          d="m392.34 820.6-101.49-16.44c-.46-.07-.77-.5-.69-.96s.5-.77.96-.69l101.49 16.44c.46.07.77.5.69.96s-.5.77-.96.69Z"
          className="cls-4cn2"
        />
        <path
          d="M289.89 803.07a.828.828 0 0 1-.54-.32l-61.65-82.28c-.28-.37-.2-.9.17-1.17.37-.28.9-.2 1.17.17l61.65 82.28c.28.37.2.9-.17 1.17-.19.14-.42.19-.64.16Z"
          className="cls-4cn2"
        />
        <path
          d="M352.34 886.41a.828.828 0 0 1-.54-.32l-61.65-82.28c-.28-.37-.2-.9.17-1.17.37-.28.9-.2 1.17.17l61.65 82.28c.28.37.2.9-.17 1.17-.19.14-.42.19-.64.16Z"
          className="cls-4cn2"
        />
        <path
          d="M207.88 866.18a.832.832 0 0 1-.37-1.49l82.28-61.65c.37-.28.9-.2 1.17.17s.2.9-.17 1.17l-82.28 61.65c-.19.14-.42.19-.64.16Z"
          className="cls-4cn2"
        />
        <path
          d="M291.22 803.73a.832.832 0 0 1-.37-1.49l82.28-61.65c.37-.28.9-.2 1.17.17.28.37.2.9-.17 1.17l-82.28 61.65c-.19.14-.42.19-.64.16ZM289.49 801.92a.617.617 0 0 1-.51-.48l-17.3-75.31c-.08-.34.13-.68.47-.75.34-.08.68.13.76.47l17.3 75.31c.08.34-.13.68-.47.75-.08.02-.16.02-.24 0Z"
          className="cls-4cn2"
        />
        <path
          d="M307.01 878.2a.617.617 0 0 1-.51-.48l-17.3-75.31c-.08-.34.13-.68.47-.75s.68.13.76.47l17.3 75.31c.08.34-.13.68-.47.75-.08.02-.16.02-.24 0Z"
          className="cls-4cn2"
        />
        <path
          d="M213.92 820.3a.617.617 0 0 1-.51-.48c-.08-.34.13-.68.47-.75l75.31-17.3c.34-.08.68.13.76.47.08.34-.13.68-.47.75l-75.31 17.3c-.08.02-.16.02-.24 0Z"
          className="cls-4cn2"
        />
        <path
          d="M290.2 802.78a.617.617 0 0 1-.51-.48c-.08-.34.13-.68.47-.75l75.31-17.3c.34-.08.68.13.76.47.08.34-.13.68-.47.75l-75.31 17.3c-.08.02-.16.02-.24 0Z"
          className="cls-4cn2"
        />
        <path
          d="M289.35 802.25a.505.505 0 0 1-.23-.09l-65.38-41.19c-.29-.19-.38-.57-.2-.87s.57-.38.87-.2l65.38 41.19c.29.19.38.57.2.87-.14.22-.39.33-.63.29Z"
          className="cls-4cn2"
        />
        <path
          d="M355.58 843.96a.505.505 0 0 1-.23-.09l-65.38-41.18a.64.64 0 0 1-.2-.87.64.64 0 0 1 .87-.2l65.38 41.18c.29.19.38.57.2.87-.14.22-.39.33-.63.29Z"
          className="cls-4cn2"
        />
        <path
          d="M248.75 868.58a.64.64 0 0 1-.43-.96l41.19-65.38a.64.64 0 0 1 .87-.2c.29.19.38.57.2.87l-41.19 65.38c-.14.22-.39.33-.63.29Z"
          className="cls-4cn2"
        />
        <path
          d="M290.46 802.36a.64.64 0 0 1-.43-.96l41.18-65.38a.64.64 0 0 1 .87-.2c.29.19.38.57.2.87l-41.18 65.38c-.14.22-.39.33-.63.29Z"
          className="cls-4cn2"
        />
        <circle cx={268.28} cy={705.03} r={7.11} className="cls-4cn2" />
        <circle cx={341.92} cy={719.29} r={7.11} className="cls-4cn2" />
        <circle cx={385.32} cy={780.55} r={7.11} className="cls-4cn2" />
        <circle cx={372.42} cy={851.95} r={7.11} className="cls-4cn2" />
        <circle cx={311.39} cy={894.39} r={7.11} className="cls-4cn2" />
        <circle cx={239.49} cy={882.74} r={7.11} className="cls-4cn2" />
        <circle cx={196.57} cy={822.63} r={7.11} className="cls-4cn2" />
        <circle cx={208.67} cy={747.94} r={7.11} className="cls-4cn2" />
        <path
          d="M1700.76 1144.65c34.5-2.14 66.97 17.14 81.61 48.44 33.82-7.23 68.81 7.04 87.92 35.86s18.64 66.61-1.19 94.95c23.18 25.67 28.32 63.11 12.92 94.07-15.4 30.96-48.36 49.45-82.81 46.45-10.66 32.88-40.5 56.02-75 58.16-34.5 2.14-66.97-17.14-81.61-48.44-33.82 7.23-68.81-7.04-87.92-35.86s-18.64-66.61 1.19-94.95c-23.18-25.67-28.32-63.1-12.92-94.07 15.4-30.96 48.36-49.45 82.81-46.45 10.66-32.88 40.5-56.02 75-58.16Z"
          className="cls-4cn2"
        />
        <path
          d="M1701.26 1155.45c32.53-2.02 63.14 16.16 76.95 45.68 31.89-6.82 64.88 6.63 82.9 33.81 18.02 27.18 17.57 62.81-1.12 89.52 21.86 24.2 26.71 59.5 12.18 88.7-14.52 29.2-45.6 46.63-78.08 43.8-10.05 31-38.19 52.82-70.71 54.84-32.53 2.02-63.14-16.16-76.95-45.68-31.89 6.82-64.88-6.63-82.9-33.81-18.02-27.18-17.57-62.81 1.12-89.52-21.86-24.2-26.71-59.5-12.18-88.7 14.52-29.2 45.6-46.63 78.08-43.8 10.05-31 38.19-52.82 70.71-54.84Z"
          className="cls-4cn1"
        />
        <circle cx={1710.72} cy={1335.86} r={33.28} className="cls-4cn2" />
        <path
          d="M1711.83 1334.9c-.46 0-.83-.37-.83-.83v-101.63c0-.46.37-.83.83-.83s.83.37.83.83v101.63c0 .46-.37.83-.83.83Z"
          className="cls-4cn2"
        />
        <path
          d="M1711.83 1437.84c-.46 0-.83-.37-.83-.83v-101.63c0-.46.37-.83.83-.83s.83.37.83.83v101.63c0 .46-.37.83-.83.83Z"
          className="cls-4cn2"
        />
        <path
          d="M1711.18 1336.21h-101.63c-.46 0-.83-.37-.83-.83s.37-.83.83-.83h101.63c.46 0 .83.37.83.83s-.37.83-.83.83Z"
          className="cls-4cn2"
        />
        <path
          d="M1814.11 1336.21h-101.63c-.46 0-.83-.37-.83-.83s.37-.83.83-.83h101.63c.46 0 .83.37.83.83s-.37.83-.83.83Z"
          className="cls-4cn2"
        />
        <path
          d="M1711.38 1335.31a.87.87 0 0 1-.58-.23l-73.16-70.54a.824.824 0 0 1-.02-1.17c.32-.33.84-.34 1.17-.02l73.16 70.54a.824.824 0 0 1-.58 1.42Z"
          className="cls-4cn2"
        />
        <path
          d="M1785.48 1406.75a.87.87 0 0 1-.58-.23l-73.16-70.54a.824.824 0 0 1-.02-1.17c.32-.33.84-.34 1.17-.02l73.16 70.54a.824.824 0 0 1-.58 1.42Z"
          className="cls-4cn2"
        />
        <path
          d="M1641.33 1409.85a.87.87 0 0 1-.58-.23.824.824 0 0 1-.02-1.17l70.54-73.16c.32-.33.84-.34 1.17-.02s.34.84.02 1.17l-70.54 73.16c-.16.17-.38.25-.6.25Z"
          className="cls-4cn2"
        />
        <path
          d="M1712.77 1335.74a.87.87 0 0 1-.58-.23.824.824 0 0 1-.02-1.17l70.54-73.16c.32-.33.84-.34 1.17-.02.33.32.34.84.02 1.17l-70.54 73.16c-.16.17-.38.25-.6.25ZM1710.8 1334.24c-.25 0-.48-.15-.58-.39l-28.78-70.75c-.13-.32.02-.68.34-.81s.68.02.81.34l28.78 70.75c.13.32-.02.68-.34.81-.08.03-.16.05-.23.05Z"
          className="cls-4cn2"
        />
        <path
          d="M1739.96 1405.91c-.25 0-.48-.15-.58-.39l-28.78-70.75c-.13-.32.02-.68.34-.81s.68.02.81.34l28.78 70.75c.13.32-.02.68-.34.81-.08.03-.16.05-.23.05Z"
          className="cls-4cn2"
        />
        <path
          d="M1639.97 1364.12c-.25 0-.48-.15-.58-.39-.13-.32.02-.68.34-.81l70.75-28.78c.32-.13.68.02.81.34s-.02.68-.34.81l-70.75 28.78c-.08.03-.16.05-.23.05Z"
          className="cls-4cn2"
        />
        <path
          d="M1711.63 1334.97c-.25 0-.48-.15-.58-.39-.13-.32.02-.68.34-.81l70.75-28.78c.32-.13.68.02.81.34s-.02.68-.34.81l-70.75 28.78c-.08.03-.16.05-.23.05Z"
          className="cls-4cn2"
        />
        <path
          d="M1710.72 1334.58c-.08 0-.16-.02-.24-.05l-70.31-29.85a.625.625 0 1 1 .49-1.15l70.31 29.85a.625.625 0 0 1-.24 1.2Z"
          className="cls-4cn2"
        />
        <path
          d="M1781.94 1364.82c-.08 0-.16-.02-.24-.05l-70.31-29.85a.625.625 0 1 1 .49-1.15l70.31 29.85a.625.625 0 0 1-.24 1.2Z"
          className="cls-4cn2"
        />
        <path
          d="M1681.58 1405.73a.625.625 0 0 1-.57-.87l29.85-70.31a.625.625 0 1 1 1.15.49l-29.85 70.31c-.1.24-.33.38-.57.38Z"
          className="cls-4cn2"
        />
        <path
          d="M1711.82 1334.52a.625.625 0 0 1-.57-.87l29.85-70.31a.625.625 0 1 1 1.15.49l-29.85 70.31c-.1.24-.33.38-.57.38Z"
          className="cls-4cn2"
        />
        <circle cx={1674.79} cy={1243.06} r={7.03} className="cls-4cn2" />
        <circle cx={1748.9} cy={1245.34} r={7.03} className="cls-4cn2" />
        <circle cx={1800.93} cy={1298.24} r={7.03} className="cls-4cn2" />
        <circle cx={1799.63} cy={1369.95} r={7.03} className="cls-4cn2" />
        <circle cx={1746.78} cy={1421.01} r={7.03} className="cls-4cn2" />
        <circle cx={1674.79} cy={1421.01} r={7.03} className="cls-4cn2" />
        <circle cx={1623.41} cy={1369.14} r={7.03} className="cls-4cn2" />
        <circle cx={1623.41} cy={1294.34} r={7.03} className="cls-4cn2" />
        <path
          d="M654.3 261.79c13.96-.87 27.1 6.93 33.02 19.6 13.68-2.93 27.84 2.85 35.57 14.51s7.54 26.95-.48 38.42c9.38 10.38 11.46 25.53 5.23 38.06-6.23 12.53-19.57 20.01-33.51 18.8-4.31 13.3-16.39 22.67-30.34 23.53-13.96.87-27.1-6.93-33.02-19.6-13.68 2.93-27.84-2.85-35.57-14.51s-7.54-26.95.48-38.42c-9.38-10.38-11.46-25.53-5.23-38.06 6.23-12.53 19.57-20.01 33.51-18.8 4.31-13.3 16.39-22.67 30.34-23.53Z"
          className="cls-4cn2"
        />
        <path
          d="M654.51 266.15c13.16-.82 25.55 6.54 31.13 18.48 12.9-2.76 26.25 2.68 33.54 13.68 7.29 11 7.11 25.41-.46 36.22 8.84 9.79 10.81 24.07 4.93 35.89-5.88 11.81-18.45 18.87-31.59 17.72-4.07 12.54-15.45 21.37-28.61 22.19-13.16.82-25.55-6.54-31.13-18.48-12.9 2.76-26.25-2.68-33.54-13.68-7.29-11-7.11-25.41.46-36.22-8.84-9.79-10.81-24.07-4.93-35.89 5.88-11.81 18.45-18.87 31.59-17.72 4.07-12.54 15.45-21.37 28.61-22.19Z"
          className="cls-4cn1"
        />
        <circle cx={658.33} cy={339.15} r={13.47} className="cls-4cn2" />
        <path
          d="M658.78 338.76c-.19 0-.34-.15-.34-.34V297.3c0-.19.15-.34.34-.34s.34.15.34.34v41.12c0 .19-.15.34-.34.34Z"
          className="cls-4cn2"
        />
        <path
          d="M658.78 380.41c-.19 0-.34-.15-.34-.34v-41.12c0-.19.15-.34.34-.34s.34.15.34.34v41.12c0 .19-.15.34-.34.34Z"
          className="cls-4cn2"
        />
        <path
          d="M658.52 339.29H617.4c-.19 0-.34-.15-.34-.34s.15-.34.34-.34h41.12c.19 0 .34.15.34.34s-.15.34-.34.34Z"
          className="cls-4cn2"
        />
        <path
          d="M700.17 339.29h-41.12c-.19 0-.34-.15-.34-.34s.15-.34.34-.34h41.12c.19 0 .34.15.34.34s-.15.34-.34.34Z"
          className="cls-4cn2"
        />
        <path
          d="M658.6 338.93c-.08 0-.17-.03-.23-.09l-29.6-28.54a.323.323 0 0 1 0-.47c.13-.13.34-.14.47 0l29.6 28.54c.13.13.14.34 0 .47-.07.07-.15.1-.24.1Z"
          className="cls-4cn2"
        />
        <path
          d="M688.58 367.83c-.08 0-.17-.03-.23-.09l-29.6-28.54a.323.323 0 0 1 0-.47c.13-.13.34-.14.47 0l29.6 28.54c.13.13.14.34 0 .47-.07.07-.15.1-.24.1Z"
          className="cls-4cn2"
        />
        <path
          d="M630.26 369.09c-.08 0-.17-.03-.23-.09a.323.323 0 0 1 0-.47l28.54-29.6c.13-.13.34-.14.47 0s.14.34 0 .47L630.5 369c-.07.07-.15.1-.24.1Z"
          className="cls-4cn2"
        />
        <path
          d="M659.16 339.1c-.08 0-.17-.03-.23-.09a.323.323 0 0 1 0-.47l28.54-29.6c.13-.13.34-.14.47 0 .13.13.14.34 0 .47l-28.54 29.6c-.07.07-.15.1-.24.1ZM658.37 338.5c-.1 0-.19-.06-.23-.16l-11.65-28.63c-.05-.13 0-.28.14-.33.13-.05.28 0 .33.14l11.65 28.63c.05.13 0 .28-.14.33-.03.01-.06.02-.09.02Z"
          className="cls-4cn2"
        />
        <path
          d="M670.16 367.49c-.1 0-.19-.06-.23-.16l-11.65-28.63c-.05-.13 0-.28.14-.33s.28 0 .33.14l11.65 28.63c.05.13 0 .28-.14.33-.03.01-.06.02-.09.02Z"
          className="cls-4cn2"
        />
        <path
          d="M629.71 350.59c-.1 0-.19-.06-.23-.16-.05-.13 0-.28.14-.33l28.63-11.65c.13-.05.28 0 .33.14.05.13 0 .28-.14.33l-28.63 11.65s-.06.02-.09.02Z"
          className="cls-4cn2"
        />
        <path
          d="M658.7 338.79c-.1 0-.19-.06-.23-.16-.05-.13 0-.28.14-.33l28.63-11.65c.13-.05.28 0 .33.14.05.13 0 .28-.14.33l-28.63 11.65s-.06.02-.09.02Z"
          className="cls-4cn2"
        />
        <path
          d="M658.33 338.63s-.07 0-.1-.02l-28.45-12.08c-.13-.05-.19-.2-.13-.33s.2-.19.33-.13l28.45 12.08c.13.05.19.2.13.33-.04.1-.13.15-.23.15Z"
          className="cls-4cn2"
        />
        <path
          d="M687.15 350.87s-.07 0-.1-.02l-28.45-12.08a.242.242 0 0 1-.13-.33c.05-.13.2-.19.33-.13l28.45 12.08c.13.05.19.2.13.33-.04.1-.13.15-.23.15Z"
          className="cls-4cn2"
        />
        <path
          d="M646.55 367.42s-.07 0-.1-.02a.242.242 0 0 1-.13-.33l12.08-28.45c.05-.13.2-.19.33-.13.13.05.19.2.13.33l-12.08 28.45c-.04.1-.13.15-.23.15Z"
          className="cls-4cn2"
        />
        <path
          d="M658.78 338.61s-.07 0-.1-.02a.242.242 0 0 1-.13-.33l12.08-28.45c.05-.13.2-.19.33-.13.13.05.19.2.13.33l-12.08 28.45c-.04.1-.13.15-.23.15Z"
          className="cls-4cn2"
        />
        <circle cx={643.8} cy={301.6} r={2.85} className="cls-4cn2" />
        <circle cx={673.78} cy={302.52} r={2.85} className="cls-4cn2" />
        <circle cx={694.83} cy={323.93} r={2.85} className="cls-4cn2" />
        <circle cx={694.31} cy={352.94} r={2.85} className="cls-4cn2" />
        <circle cx={672.92} cy={373.6} r={2.85} className="cls-4cn2" />
        <circle cx={643.8} cy={373.6} r={2.85} className="cls-4cn2" />
        <circle cx={623.01} cy={352.62} r={2.85} className="cls-4cn2" />
        <circle cx={623.01} cy={322.35} r={2.85} className="cls-4cn2" />
        <path
          d="M1680.64 1072.85c0-115.85-72.83-187.79-85.48-199.88 3.13-17.17 19.84-118.24-48.3-211.97-68.15-93.75-169.47-109.02-186.77-111.33-7.49-15.69-53.24-107.5-163.52-143.32-110.3-35.83-201.28 11.59-216.56 19.88-15.27-8.29-106.26-55.71-216.55-19.88-110.28 35.82-156.03 127.63-163.52 143.32-17.3 2.31-118.62 17.58-186.78 111.33-68.14 93.73-51.43 194.8-48.29 211.97-12.65 12.09-85.48 84.03-85.48 199.88s72.83 187.8 85.48 199.88c-3.14 17.18-19.85 118.24 48.29 211.97 68.16 93.75 169.48 109.03 186.78 111.34 7.49 15.68 53.24 107.5 163.52 143.32 110.29 35.83 201.28-11.59 216.55-19.88 15.28 8.29 106.26 55.71 216.56 19.88 110.28-35.82 156.03-127.63 163.52-143.32 17.3-2.31 118.62-17.59 186.77-111.34 68.14-93.73 51.43-194.79 48.3-211.97 12.65-12.08 85.48-84.02 85.48-199.88Zm-347.27-165.06v330.13c0 103.99-84.3 188.3-188.3 188.3H814.95c-103.99 0-188.3-84.31-188.3-188.3V907.79c0-103.99 84.31-188.3 188.3-188.3h330.12c104 0 188.3 84.31 188.3 188.3Z"
          className="cls-4cn2"
        />
        <path
          d="M1554.22 1072.85c0-94.94-59.69-153.91-70.06-163.81 2.57-14.08 16.26-96.91-39.58-173.72-55.86-76.84-138.89-89.35-153.07-91.25-6.14-12.85-43.64-88.1-134.02-117.46-90.39-29.36-164.96 9.5-177.48 16.3-12.52-6.8-87.08-45.66-177.48-16.3-90.38 29.36-127.87 104.61-134.01 117.46-14.18 1.9-97.22 14.41-153.07 91.25-55.85 76.82-42.16 159.65-39.59 173.72-10.36 9.9-70.05 68.87-70.05 163.81s59.69 153.91 70.05 163.82c-2.57 14.07-16.26 96.9 39.59 173.72 55.85 76.83 138.89 89.35 153.07 91.25 6.14 12.85 43.63 88.1 134.01 117.46 90.4 29.36 164.96-9.51 177.48-16.3 12.52 6.79 87.09 45.66 177.48 16.29 90.38-29.35 127.88-104.6 134.02-117.45 14.18-1.9 97.21-14.42 153.07-91.25 55.84-76.82 42.15-159.65 39.58-173.72 10.37-9.91 70.05-68.87 70.06-163.82Zm-220.85 165.07c0 103.99-84.3 188.3-188.3 188.3H814.95c-103.99 0-188.3-84.31-188.3-188.3V907.79c0-103.99 84.31-188.3 188.3-188.3h330.12c104 0 188.3 84.31 188.3 188.3v330.13Z"
          className="cls-4cn1"
        />
        <path
          d="M1588.56 1194.21c16.94-30.94 31.42-71.87 31.42-121.36 0-98.97-57.94-163.72-77.52-182.75 4.68-26.91 13.54-113.36-44.67-193.44-58.23-80.09-143.2-98.32-170.26-102.17-11.99-24.57-55.5-99.84-149.71-130.44-94.23-30.61-173.67 4.74-197.81 17.57-24.14-12.83-103.58-48.18-197.8-17.57-94.22 30.61-137.72 105.87-149.71 130.44-27.06 3.85-112.04 22.08-170.26 102.17-58.22 80.08-49.35 166.53-44.67 193.44-19.59 19.03-77.52 83.77-77.52 182.75s57.93 163.73 77.52 182.76c-4.68 26.91-13.55 113.35 44.67 193.44s143.2 98.32 170.26 102.17c11.98 24.56 55.49 99.83 149.71 130.43 27.09 8.8 52.95 12.15 76.63 12.15 58.69 0 103.97-20.57 121.17-29.72 17.21 9.15 62.47 29.72 121.18 29.72 23.67 0 49.55-3.35 76.63-12.15 94.21-30.6 137.72-105.86 149.71-130.43 27.06-3.85 112.03-22.08 170.25-102.17s49.36-166.54 44.68-193.44c9.79-9.52 29.17-30.46 46.1-61.4Zm-51.82 60.92c4.48 24.55 14.58 110.83-43.44 190.66-58.04 79.83-143.26 96.83-167.99 100.13l-1.49.2-.65 1.36c-10.75 22.52-53.15 98.39-147.06 128.9-93.93 30.51-172.83-5.98-194.77-17.89l-1.33-.71-1.32.71c-21.94 11.91-100.84 48.4-194.77 17.89-93.91-30.51-136.31-106.38-147.07-128.9l-.65-1.36-1.48-.2c-24.74-3.3-109.95-20.3-167.99-100.13-58.03-79.83-47.92-166.11-43.44-190.66l.27-1.47-1.08-1.03c-18.04-17.23-76.88-81.12-76.88-179.78s58.84-162.54 76.88-179.77l1.08-1.04-.27-1.47c-4.48-24.54-14.59-110.83 43.44-190.65 58.04-79.84 143.25-96.83 167.99-100.14l1.48-.2.65-1.35c10.76-22.53 53.16-98.4 147.07-128.9 26.5-8.61 51.79-11.88 74.96-11.88 58.94 0 104.06 21.21 119.81 29.76l1.32.72 1.33-.72c21.94-11.91 100.84-48.39 194.76-17.88 93.91 30.5 136.32 106.37 147.07 128.9l.65 1.35 1.49.2c24.73 3.31 109.95 20.31 167.99 100.14 58.02 79.82 47.92 166.11 43.44 190.65l-.27 1.47 1.08 1.04c18.03 17.23 76.88 81.12 76.88 179.77s-58.85 162.55-76.88 179.78l-1.08 1.03.27 1.47Z"
          className="cls-4cn1"
        />
        {children}
      </g>
    </svg>
  );
}
